import { State } from "./state";
import { storeInit } from "../../../Store";

const ch: State.Channel = {
  idx: 0,
  type: "Fail Safe",
  v: 0,
  vcal: 0,
  voff: 0,
  i: 0,
  ical: 0,
  ioff: 0,
  input: -1,
  input_inv: false,
  noNc: false,
  iHigh: 0,
  iLow: 0,
  vHigh: 0,
  vLow: 0,
  facp: false,
  facpOnOff: false,
  _facpCtrl: "Inactive",
  latch: false,
  bBackup: false,
  id: "",
  eolFacp: false,
  triggered: false,
  locked: false,
  out_timer: 0,
  pcycl_dur: 0
};

const chs: State.Data = [
  { ...ch },
  { ...ch },
  { ...ch },
  { ...ch },
  { ...ch },
  { ...ch },
  { ...ch },
  { ...ch }
];

export const initial: State.Props = storeInit(chs);
export default initial;
